/* TORQEN storefront behaviour — vehicle finder, configurator, gallery, request form.
   No framework, no build step. Everything degrades to a usable page. */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Diagnostics. The storefront is password-protected and cannot be reached from
     the build environment, so this is how a human confirms what actually loaded:
     open the console and read TORQEN_DEBUG. It is a handful of counters, not
     tracking, and it costs nothing. */
  var DEBUG = window.TORQEN_DEBUG = {
    vehiclesJson: 'absent', fitmentJson: 'absent',
    brands: 0, models: 0, brandsWithNoModels: [], fitmentProducts: 0,
    i18n: !!window.TORQEN_I18N, form: false, errors: []
  };
  function note(e) { DEBUG.errors.push(String(e && e.message || e)); }

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (e) { note(id + ': ' + e.message); return null; }
  }

  function t(key, fallback) {
    var d = window.TORQEN_I18N || {};
    return d[key] || fallback;
  }

  /* `required` is set from JavaScript, never in the markup. A <select required>
     that JavaScript failed to populate is unsatisfiable: the browser refuses to
     submit and parks an error bubble on a control with nothing in it, which is
     what made the request form impossible to send. A control is only ever
     required here once it actually has something to choose. */
  function setRequired(el, on) {
    if (!el) return;
    if (on) el.setAttribute('required', 'required');
    else el.removeAttribute('required');
  }

  /* ------------------------------------------------ mobile nav */
  var burger = $('#burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var nav = $('#nav');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ------------------------------------------------ vehicle data */
  var raw = readJSON('torqen-vehicles');
  var fitment = readJSON('torqen-fitment') || {};
  DEBUG.vehiclesJson = raw ? 'parsed' : (document.getElementById('torqen-vehicles') ? 'PARSE FAILED' : 'absent');
  DEBUG.fitmentJson = document.getElementById('torqen-fitment')
    ? (DEBUG.errors.join(' ').indexOf('torqen-fitment') === -1 ? 'parsed' : 'PARSE FAILED')
    : 'absent';
  DEBUG.fitmentProducts = Object.keys(fitment).length;

  // generations is a json-typed metaobject field, so it arrives as an array.
  // Tolerate a string anyway: if the field type is ever changed to text the
  // finder should degrade to "no generations listed", not throw.
  function parseGens(g) {
    if (!g) return [];
    if (typeof g === 'string') { try { g = JSON.parse(g); } catch (e) { return []; } }
    return Array.isArray(g) ? g : [];
  }

  var brands = ((raw && raw.brands) || []).slice().sort(function (a, b) {
    return (a.order == null ? 999 : a.order) - (b.order == null ? 999 : b.order);
  });

  // Group the flat model list under its brand slug. This is the join that used
  // to happen in Liquid, where it cost 2280 metaobject reference lookups.
  var modelsByBrand = {};
  ((raw && raw.models) || []).forEach(function (m) {
    if (!m || !m.brand || !m.slug) return;
    if (!modelsByBrand[m.brand]) modelsByBrand[m.brand] = [];
    modelsByBrand[m.brand].push({ slug: m.slug, name: m.name || m.slug, gens: parseGens(m.gens) });
  });

  DEBUG.brands = brands.length;
  DEBUG.models = ((raw && raw.models) || []).length;
  DEBUG.brandsWithNoModels = brands
    .filter(function (b) { return !(modelsByBrand[b.slug] || []).length; })
    .map(function (b) { return b.slug; });

  /* ------------------------------------------------ vehicle finder */
  var bSel = $('#tqBrand'), mSel = $('#tqModel'), gSel = $('#tqGen'), ySel = $('#tqYear');
  var out  = $('#tqOut'),   res  = $('#tqResults');

  function opt(sel, value, label) {
    var o = document.createElement('option');
    o.value = value; o.textContent = label;
    sel.appendChild(o);
  }
  function reset(sel, placeholder) {
    if (!sel) return;
    sel.innerHTML = '';
    opt(sel, '', placeholder);
    sel.disabled = true;
    setRequired(sel, false);
  }

  // "2018-" or "2013-2019" -> a concrete list of years, newest first.
  function yearsOf(range) {
    if (!range) return [];
    var m = String(range).match(/(\d{4})\s*[-–—]\s*(\d{4})?/);
    if (!m) return [];
    var from = parseInt(m[1], 10);
    var to = m[2] ? parseInt(m[2], 10) : new Date().getFullYear();
    if (to < from) to = from;
    var years = [];
    for (var y = to; y >= from; y--) years.push(y);
    return years;
  }

  /* Each subsystem is isolated. Previously this was one flat IIFE: a throw
     anywhere (a malformed vehicle JSON, a missing element) aborted every
     later block, so one fault in the finder silently took the configurator,
     the gallery and the whole request form down with it. That is why the
     page could look entirely dead from a single cause. Now a failure is
     recorded in TORQEN_DEBUG.errors and the other subsystems still run. */
  try {
  if (bSel && mSel && gSel && ySel) {
    var curBrand = null, curModel = null, curGen = null;

    reset(mSel, t('model', 'Select model'));
    reset(gSel, t('gen', 'Select generation'));
    reset(ySel, t('year', 'Select year'));

    bSel.innerHTML = '';
    opt(bSel, '', t('brand', 'Select brand'));
    brands.forEach(function (b) { opt(bSel, b.slug, b.name); });
    setRequired(bSel, brands.length > 0);

    bSel.addEventListener('change', function () {
      curBrand = brands.filter(function (b) { return b.slug === bSel.value; })[0] || null;
      curModel = null; curGen = null;
      reset(mSel, t('model', 'Select model'));
      reset(gSel, t('gen', 'Select generation'));
      reset(ySel, t('year', 'Select year'));
      if (!curBrand) { render(); return; }

      var list = modelsByBrand[curBrand.slug] || [];
      list.forEach(function (m) { opt(mSel, m.slug, m.name); });
      mSel.disabled = list.length === 0;
      setRequired(mSel, list.length > 0);
      render();
    });

    mSel.addEventListener('change', function () {
      var list = (curBrand && modelsByBrand[curBrand.slug]) || [];
      curModel = list.filter(function (m) { return m.slug === mSel.value; })[0] || null;
      curGen = null;
      reset(gSel, t('gen', 'Select generation'));
      reset(ySel, t('year', 'Select year'));
      if (!curModel) { render(); return; }

      var gens = curModel.gens || [];
      gens.forEach(function (g, i) { opt(gSel, String(i), (g.code || '?') + '  ·  ' + (g.years || '')); });
      gSel.disabled = gens.length === 0;
      // Required only where the vehicle genuinely has generations listed. A model
      // with none must not be able to block the form: that would demand a value
      // that does not exist rather than one the customer forgot.
      setRequired(gSel, gens.length > 0);
      render();
    });

    gSel.addEventListener('change', function () {
      var gens = (curModel && curModel.gens) || [];
      curGen = gens[parseInt(gSel.value, 10)] || null;
      reset(ySel, t('year', 'Select year'));
      if (!curGen) { render(); return; }
      var ys = yearsOf(curGen.years);
      ys.forEach(function (y) { opt(ySel, String(y), String(y)); });
      ySel.disabled = ys.length === 0;
      setRequired(ySel, ys.length > 0);
      render();
    });

    ySel.addEventListener('change', render);

    function matches() {
      if (!curBrand || !curModel) return [];
      var key = curBrand.slug + '/' + curModel.slug;
      var hits = [];
      Object.keys(fitment).forEach(function (handle) {
        var p = fitment[handle];
        if (p && p.fits && p.fits.indexOf(key) !== -1) hits.push(p);
      });
      return hits;
    }

    function render() {
      if (!out) return;

      if (!brands.length) {
        out.innerHTML = '<b>' + t('nomatch', 'nothing listed for this vehicle yet') + '</b>';
        return;
      }

      var parts = [];
      if (curBrand) parts.push(curBrand.name);
      if (curModel) parts.push(curModel.name);
      if (curGen) parts.push(curGen.code);
      if (ySel.value) parts.push(ySel.value);

      if (!curBrand) {
        out.innerHTML = t('start', 'Start by choosing your vehicle brand.');
        if (res) res.innerHTML = '';
        return;
      }
      if (!curModel) {
        out.innerHTML = '<b>' + parts.join(' · ') + '</b> — ' + t('pickmodel', 'now choose your model.');
        if (res) res.innerHTML = '';
        return;
      }

      var hits = matches();
      // Phrased "<label>: <n>" rather than "<n> wheels match" — the noun inflects
      // by count in five of the seven storefront languages and JS has no access
      // to Shopify's pluralisation rules.
      out.innerHTML = '<b>' + parts.join(' · ') + '</b> — ' +
        (hits.length
          ? t('matching', 'Matching wheels') + ': ' + hits.length
          : t('nomatch', 'nothing listed for this vehicle yet'));

      if (!res) return;
      if (!hits.length) {
        var routes = window.TORQEN_ROUTES || {};
        res.innerHTML =
          '<div class="sec sec--tight"><div class="notice">' +
          t('nomatch_body', 'We have nothing listed for this vehicle yet — but we can still ask our supplier for you.') +
          ' <a href="' + (routes.custom || '/pages/custom-request') + '" style="color:var(--red-hi)">' +
          t('nomatch_cta', 'Send a custom request') + ' &rarr;</a></div></div>';
        return;
      }

      var html = '<div class="sec sec--tight"><div class="grid grid--4">';
      hits.forEach(function (p) {
        html += '<a class="card" href="' + p.url + '">' +
          '<div class="card__img' + (p.img ? '' : ' card__img--empty') + '">' +
            (p.img ? '<img src="' + p.img + '" alt="" loading="lazy" width="500" height="500">' : '') +
          '</div>' +
          '<div class="card__body">' +
            '<span class="card__fit">' + (curBrand.name + ' ' + curModel.name) + '</span>' +
            '<span class="card__t">' + p.title + '</span>' +
            '<span class="card__meta"><span class="card__from">' + (p.from || '') + '</span>' +
            '<span>' + t('view', 'View') + ' &rarr;</span></span>' +
          '</div></a>';
      });
      html += '</div></div>';
      res.innerHTML = html;
    }

    render();
  }
  } catch (e) { note('finder: ' + (e && e.message || e)); }

  /* ------------------------------------------------ product gallery */
  try {
  var gMain = $('#galMain');
  if (gMain) {
    $$('.gal__thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-full');
        if (src) gMain.src = src;
        $$('.gal__thumbs button').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
      });
    });
  }
  } catch (e) { note('gallery: ' + (e && e.message || e)); }

  /* ------------------------------------------------ request form */
  var form = $('#requestForm');
  DEBUG.form = !!form;
  try {
  if (form) {

  var sum = $('#cfgSummary');

  function groupOf(el) {
    var n = el;
    while (n && n !== form) {
      if (n.getAttribute && n.getAttribute('data-cfg') !== null) return n;
      n = n.parentNode;
    }
    return null;
  }

  /* The chip is a <label> wrapping a visually-hidden radio. That alone is enough
     for the browser to record the choice, but it leaves the selected state
     resting entirely on the `input:checked + span` CSS rule — if that rule is
     ever lost the option still selects and the customer simply cannot see it.
     Mirroring the state onto the label as a class means the selection is visible
     from two independent places, and gives us something to assert against. */
  function paint(group) {
    if (!group) return;
    $$('.chip', group).forEach(function (label) {
      var r = label.querySelector('input[type=radio]');
      label.classList.toggle('is-on', !!(r && r.checked));
    });
  }

  function updateSummary() {
    if (!sum) return;
    var rows = [];
    $$('[data-cfg]', form).forEach(function (group) {
      // data-cfg is the English property name that reaches the order; the
      // customer-facing summary uses the translated label instead.
      var name = group.getAttribute('data-cfg-label') || group.getAttribute('data-cfg');
      var checked = group.querySelector('input:checked');
      // an empty value is the "not selected" chip, not a choice
      if (checked && checked.value) {
        // The radio VALUE is deliberately English because it travels to the order
        // and the supplier brief. What the customer reads back must be the
        // translated chip label, or the summary prints English into a Slovenian page.
        var chipLabel = checked.parentNode ? checked.parentNode.querySelector('span') : null;
        rows.push([name, chipLabel ? chipLabel.textContent.trim() : checked.value]);
      }
    });
    var html = '';
    rows.forEach(function (r) { html += '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; });
    sum.innerHTML = html || '<dt>—</dt><dd>' + t('nocfg', 'No options selected yet') + '</dd>';
  }

  $$('[data-cfg] input[type=radio]', form).forEach(function (r) {
    r.addEventListener('change', function () { paint(groupOf(r)); updateSummary(); });
  });
  $$('[data-cfg]', form).forEach(paint);
  form.addEventListener('change', updateSummary);
  updateSummary();

  /* ---------------------------------------------- photo upload guard
     Two things go wrong in the wild and both are worth catching in the browser
     rather than at checkout:

     1. Size. Shopify's native line-item-property upload caps at 20 MB.
     2. HEIC. iPhones shoot HEIC by default. Safari transcodes to JPEG when the
        file is picked from Photos and `accept` does not list HEIC — which is
        exactly why accept is jpeg/png/webp only. But a customer who picks the
        same photo through the Files app gets the raw .heic, which lands in the
        order as a file neither Shopify's admin preview nor a Windows machine
        will open. Better to say so here than to hand the owner an unopenable
        attachment. */
  var LIMIT = 20 * 1024 * 1024;
  var photoName = '';

  function uploadError(inp, message) {
    var note = inp.parentNode.querySelector('.upload__err');
    if (note) note.remove();
    var d = document.createElement('div');
    d.className = 'upload__note upload__err';
    d.style.color = 'var(--red-hi)';
    d.textContent = message;
    inp.parentNode.appendChild(d);
    inp.value = '';
    photoName = '';
  }

  $$('input[type=file]', form).forEach(function (inp) {
    inp.addEventListener('change', function () {
      var note = inp.parentNode.querySelector('.upload__err');
      if (note) note.remove();
      photoName = '';

      var files = Array.prototype.slice.call(inp.files || []);
      if (!files.length) return;

      var heic = files.filter(function (f) {
        return /\.hei[cf]$/i.test(f.name || '') || /^image\/hei[cf]/i.test(f.type || '');
      });
      if (heic.length) {
        uploadError(inp, t('heic', 'iPhone photos in HEIC format can’t be read here. ' +
          'Open Settings › Camera › Formats and choose “Most Compatible”, ' +
          'or take a screenshot of the photo and upload that.'));
        return;
      }
      if (files.filter(function (f) { return f.size > LIMIT; }).length) {
        uploadError(inp, t('toobig', 'That file is over 20 MB. Please choose a smaller photo.'));
        return;
      }
      photoName = files[0].name || '';
    });
  });

  /* ---------------------------------------------- validation messages
     The browser's own "Please fill out this field" bubble is written in the
     BROWSER's language, not the storefront's, so a Slovenian page shows an English
     bubble to anyone running an English browser. setCustomValidity replaces it with
     the theme's translated string. It must be cleared again on input, otherwise the
     field stays permanently invalid once it has failed once. */
  function requiredMessage(el) {
    if (el.tagName === 'SELECT') return t('required_select', '');
    if (el.type === 'file') return t('required_file', '');
    return t('required', '');
  }
  $$('input, select, textarea', form).forEach(function (el) {
    el.addEventListener('invalid', function () {
      if (el.validity.valueMissing) {
        var m = requiredMessage(el);
        if (m) el.setCustomValidity(m);
      }
    });
    var clear = function () { el.setCustomValidity(''); };
    el.addEventListener('input', clear);
    el.addEventListener('change', clear);
  });

  /* ---------------------------------------------- submit
     One handler, in order: build the brief, then stop the "not selected" chips
     from being posted. The submit event only fires once the browser is happy
     with validation, so nothing here runs on a rejected submission. */
  var brief = $('#tqBrief');

  function selText(name) {
    var el = form.querySelector('[name="properties[' + name + ']"]');
    if (!el || !el.value) return '';
    return (el.tagName === 'SELECT' && el.selectedIndex > -1)
      ? el.options[el.selectedIndex].text
      : el.value;
  }

  form.addEventListener('submit', function () {
    if (brief) {
      var L = [];
      var NS = 'Not specified';
      var wheel = form.querySelector('[name="properties[Steering wheel]"]');
      var handle = form.querySelector('[name="properties[_Wheel handle]"]');
      var wanted = form.querySelector('[name="properties[Wheel wanted]"]');
      var cur = form.querySelector('[name="properties[Current wheel description]"]');
      var notes = form.querySelector('[name="properties[Customer notes]"]');

      L.push('TORQEN REQUEST');
      L.push('');
      L.push('WHEEL');
      L.push('  Product: ' + ((wheel && wheel.value) || NS) +
             (handle && handle.value ? '  [' + handle.value + ']' : ''));
      if (wanted && wanted.value.trim()) L.push('  Wanted: ' + wanted.value.trim());

      L.push('');
      L.push('VEHICLE');
      L.push('  Brand: '      + (selText('Vehicle brand') || NS));
      L.push('  Model: '      + (selText('Vehicle model') || NS));
      L.push('  Generation: ' + (selText('Generation')    || NS));
      L.push('  Year: '       + (selText('Year')          || NS));

      L.push('');
      L.push('CONFIGURATION');
      // Every axis is listed, including the ones left alone, and those say so in
      // as many words. An omitted line would read to the supplier as "no
      // preference"; "Not specified" says the customer never answered, which is
      // the truth and is what you need to go back to them about.
      $$('[data-cfg]', form).forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var value = (checked && checked.value) ? checked.value : NS;
        L.push('  ' + group.getAttribute('data-cfg') + ': ' + value);
      });

      L.push('');
      L.push('FROM THE CUSTOMER');
      L.push('  Current wheel: ' + ((cur && cur.value.trim()) || NS));
      L.push('  Notes: '         + ((notes && notes.value.trim()) || NS));

      L.push('');
      L.push('PHOTO');
      L.push('  ' + (photoName ? photoName + ' — attached to this line item.' : NS));

      brief.value = L.join('\n');
    }

    // A radio with an empty value would post "properties[Material]=" and lean on
    // Shopify dropping blank properties. Disabling it means it is simply never
    // sent, which does not depend on that behaviour. Re-enabled on the next tick
    // so a cancelled navigation leaves the form usable.
    var blanked = $$('[data-cfg] input[type=radio]', form).filter(function (r) {
      return r.checked && r.value === '';
    });
    blanked.forEach(function (r) { r.disabled = true; });
    setTimeout(function () { blanked.forEach(function (r) { r.disabled = false; }); }, 0);
  });

  } /* end if (form) */
  } catch (e) { note('form: ' + (e && e.message || e)); }

  /* ------------------------------------------------ ?tqdebug=1 read-out
     The storefront cannot be reached from the build environment, so this panel
     is the only source of runtime truth. It reports what actually reached the
     browser, not what the templates intended. */
  /* ---------------------------------------------- language audit
     Scans what is actually on screen. Product titles, product descriptions and the
     fitment badges are CATALOGUE data, not theme strings - they are English in every
     language because the product catalogue is English, and changing it is out of
     scope - so they are removed before scanning. Everything left is theme-controlled
     and must be in the active language. */
  var EN_MARKERS = ['Not selected','Select brand','Select model','Select generation',
    'Select year','Matching wheels','No options selected yet','Find your wheel',
    'Custom request','How it works','Stitching','Heating','Paddles','Buttons',
    'Leather','Forged Carbon','Opening soon','Please fill in this field'];
  var SL_MARKERS = ['Ni izbrano','Znamka','Poišči volan','Zahteva po meri','Kako poteka',
    'Tipke','Ogrevanje','Prestavne ročice','Šivi','Usnje','Kovani karbon',
    'Ustrezni volani','Izbrana še ni nobena možnost','Kmalu odpiramo',
    'Prosimo, izpolnite to polje','Domov','Trgovina','Znamke'];

  function themeText() {
    if (!document.body) return '';
    var clone = document.body.cloneNode(true);
    ['.card__t', '.card__fit', '.pdp__fit', '.rte', '.hdr__logo', '.ftr__brand',
     '#tqBrief', '#tqDebugPanel', 'select', 'script', 'style', '.pdp h1', '.gal__thumbs'
    ].forEach(function (sel) {
      $$(sel, clone).forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
    });
    return (clone.textContent || '').replace(/\s+/g, ' ');
  }

  function langReport() {
    var loc = window.TORQEN_LOCALE || {};
    var active = loc.active || null;
    var text = '';
    var missingSl = [], missingEn = [], mixed = [];
    try {
      text = themeText();
      // Shopify prints this literal when a key has no entry in the active locale.
      var miss = text.match(/[Tt]ranslation missing: [^\s]+/g) || [];
      if (active === 'en') missingEn = miss; else missingSl = miss;
      var markers = active === 'en' ? SL_MARKERS : EN_MARKERS;
      markers.forEach(function (m) { if (text.indexOf(m) !== -1) mixed.push(m); });
    } catch (e) { note('langaudit: ' + (e && e.message || e)); }
    return {
      loaded: !!window.TORQEN_I18N,
      keys: window.TORQEN_I18N ? Object.keys(window.TORQEN_I18N).length : 0,
      languages: loc.offered || 0,
      activeLanguage: active,
      missingSlovenian: missingSl,
      missingEnglish: missingEn,
      mixedLanguageStrings: mixed
    };
  }

  function tqReport() {
    var db = {};
    Object.keys(modelsByBrand).sort().forEach(function (k) { db[k] = modelsByBrand[k].length; });

    // Which fitment keys point at a vehicle that exists in the tree, and which
    // products are therefore findable at all.
    var known = {};
    Object.keys(modelsByBrand).forEach(function (b) {
      modelsByBrand[b].forEach(function (m) { known[b + '/' + m.slug] = true; });
    });
    var reachable = 0, unmatched = {};
    Object.keys(fitment).forEach(function (h) {
      var fits = (fitment[h] && fitment[h].fits) || [];
      var hit = false;
      fits.forEach(function (k) { if (known[k]) hit = true; else unmatched[k] = true; });
      if (hit) reachable++;
    });

    // Configurator: one radio per option is the whole point, so count them.
    var groups = $$('[data-cfg]');
    var perGroup = {}, totalRadios = 0;
    groups.forEach(function (g) {
      var radios = $$('input[type=radio]', g);
      totalRadios += radios.length;
      // exclude the "not selected" chip: it is not one of the merchant's options
      perGroup[g.getAttribute('data-cfg')] = radios.filter(function (r) { return r.value !== ''; }).length;
    });

    // Duplicate element ids anywhere on the page break every getElementById call
    // that follows them, so they are worth surfacing even outside the form. The
    // id alone was not enough to act on - it named the collision but not which
    // elements collided - so each entry now carries the tag and first class of
    // every element sharing that id.
    var seenId = {}, dupIds = {};
    function describeEl(el) {
      var cls = (el.className && typeof el.className === 'string')
        ? el.className.trim().split(/\s+/)[0] : '';
      return el.tagName.toLowerCase() + (cls ? '.' + cls : '');
    }
    $$('[id]').forEach(function (el) {
      var id = el.id;
      if (!id) return;
      if (seenId[id]) {
        if (!dupIds[id]) dupIds[id] = [seenId[id]];
        dupIds[id].push(describeEl(el));
      } else {
        seenId[id] = describeEl(el);
      }
    });
    var dupReport = Object.keys(dupIds).map(function (id) {
      return id + ' (' + dupIds[id].length + '×: ' + dupIds[id].join(', ') + ')';
    });

    var env = window.TORQEN_ENV || {};
    return {
      vehicles: {
        brands: DEBUG.brands,
        models: DEBUG.models,
        brandsWithNoModels: DEBUG.brandsWithNoModels,
        modelsPerBrand: db
      },
      fitment: {
        fitmentItems: DEBUG.fitmentProducts,
        productsReachable: reachable,
        unmatchedFitments: Object.keys(unmatched),
        brandCollectionsResolved: env.brandCollectionsResolved
      },
      configurator: {
        groups: groups.length,
        optionsPerGroup: perGroup,
        totalIndividualRadios: totalRadios,
        duplicateRadioIDs: dupReport
      },
      request: {
        formPresent: DEBUG.form,
        feeProductPresent: env.feeProductPresent === true,
        feeVariantPresent: env.feeVariantPresent === true,
        feeVariantId: (form && form.querySelector('[name="id"]')) ? form.querySelector('[name="id"]').value : null,
        feePrice: env.feePrice || null,
        returnTo: (form && form.querySelector('[name="return_to"]')) ? form.querySelector('[name="return_to"]').value : null,
        supplierBriefField: !!(form && form.querySelector('[name="properties[_Supplier brief]"]')),
        photoInputPresent: !!(form && form.querySelector('input[type=file]'))
      },
      i18n: langReport(),
      errors: DEBUG.errors
    };
  }

  try {
    window.TORQEN_REPORT = tqReport;
    if (window.location && String(window.location.search).indexOf('tqdebug=1') > -1) {
      var r = tqReport();
      var L = [];
      L.push('TORQEN DEBUG');
      L.push('');
      L.push('vehicles:');
      L.push('  brands: ' + r.vehicles.brands);
      L.push('  models: ' + r.vehicles.models);
      L.push('  brandsWithNoModels: [' + r.vehicles.brandsWithNoModels.join(', ') + ']');
      L.push('  modelsPerBrand: ' + JSON.stringify(r.vehicles.modelsPerBrand));
      L.push('');
      L.push('fitment:');
      L.push('  fitmentItems: ' + r.fitment.fitmentItems);
      L.push('  productsReachable: ' + r.fitment.productsReachable);
      L.push('  unmatchedFitments: [' + r.fitment.unmatchedFitments.join(', ') + ']');
      L.push('  brandCollectionsResolved: ' + r.fitment.brandCollectionsResolved +
             (r.fitment.brandCollectionsResolved === 0
               ? '   <-- no brand collection is visible to the storefront' : ''));
      L.push('');
      L.push('configurator:');
      L.push('  groups: ' + r.configurator.groups);
      L.push('  optionsPerGroup: ' + JSON.stringify(r.configurator.optionsPerGroup));
      L.push('  totalIndividualRadios: ' + r.configurator.totalIndividualRadios +
             '   (includes one "not selected" chip per group)');
      L.push('  duplicateRadioIDs: ' + r.configurator.duplicateRadioIDs.length +
             (r.configurator.duplicateRadioIDs.length ? '  [' + r.configurator.duplicateRadioIDs.join(', ') + ']' : ''));
      L.push('');
      L.push('request:');
      L.push('  formPresent: ' + r.request.formPresent);
      L.push('  feeProductPresent: ' + r.request.feeProductPresent);
      L.push('  feeVariantPresent: ' + r.request.feeVariantPresent);
      L.push('  feeVariantId: ' + r.request.feeVariantId);
      L.push('  feePrice: ' + r.request.feePrice);
      L.push('  returnTo: ' + r.request.returnTo);
      L.push('  supplierBriefField: ' + r.request.supplierBriefField);
      L.push('  photoInputPresent: ' + r.request.photoInputPresent);
      L.push('');
      L.push('i18n:');
      L.push('  loaded: ' + r.i18n.loaded + '   (' + r.i18n.keys + ' strings)');
      L.push('  languages: ' + r.i18n.languages);
      L.push('  activeLanguage: ' + r.i18n.activeLanguage);
      L.push('  missingSlovenian: [' + r.i18n.missingSlovenian.join(', ') + ']');
      L.push('  missingEnglish: [' + r.i18n.missingEnglish.join(', ') + ']');
      L.push('  mixedLanguageStrings: [' + r.i18n.mixedLanguageStrings.join(', ') + ']');
      L.push('');
      L.push('errors: [' + r.errors.join(' | ') + ']');

      var box = document.createElement('div');
      box.id = 'tqDebugPanel';
      box.setAttribute('style',
        'position:fixed;left:0;right:0;bottom:0;z-index:99999;max-height:55vh;overflow:auto;' +
        'background:#0d0d0f;color:#f2f0ea;border-top:3px solid #a31621;padding:14px 16px;' +
        'font:12px/1.5 ui-monospace,Menlo,monospace;white-space:pre-wrap');
      box.textContent = L.join('\n');
      (document.body || document.documentElement).appendChild(box);
    }
  } catch (e) { note('debugpanel: ' + (e && e.message || e)); }

  if (window.console && console.info) {
    console.info('[TORQEN] brands=' + DEBUG.brands + ' models=' + DEBUG.models +
      ' fitment=' + DEBUG.fitmentProducts +
      (DEBUG.brandsWithNoModels.length ? ' NO-MODELS:' + DEBUG.brandsWithNoModels.join(',') : '') +
      (DEBUG.errors.length ? ' ERRORS:' + DEBUG.errors.join(' | ') : ''));
  }
})();
